import { useState, useEffect } from "react";
import { Container } from "../Container/container";
import styles from "./feelslike.css";

import image1 from "../../images/image1.svg";
import image2 from "../../images/image2.svg";
import image3 from "../../images/image3.svg";
import image4 from "../../images/image4.svg";
import image5 from "../../images/image5.svg";

export const FeelsLike = ({ city = "Lviv" }) => {
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const response = await fetch(
          `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=b8a65a4a73ec0d714d7773505232fc8b&units=metric`
        );
        const data = await response.json();
        setWeather(data);
      } catch (error) {
        console.error("Error fetching weather:", error);
      }
    };

    fetchWeather();
  }, [city]);

  if (!weather) {
    return <p>Loading...</p>;
  }

  return (
    <section id="menu" className="feelslike">
      <Container>
        <div className="feelslike__box">
          <ul className="feelslike__list">
            <li className="feelslike__item">
              <p className="feelslike__desc">Feels like</p>
              <h2 className="feelslike__text">{weather.main.feels_like}℃</h2>
              <img className="feelslike__img" src={image5} alt="Feels like" />
            </li>
            <li className="feelslike__item">
              <p className="feelslike__desc">Min ℃</p>
              <h2 className="feelslike__text">{weather.main.temp_min}℃</h2>
              <p className="feelslike__desc">Max ℃</p>
              <h2 className="feelslike__text">{weather.main.temp_max}℃</h2>
            </li>
            <li className="feelslike__item">
              <p className="feelslike__desc">Humidity</p>
              <h2 className="feelslike__text">{weather.main.humidity}%</h2>
              <img className="feelslike__img" src={image3} alt="Humidity" />
            </li>
            <li className="feelslike__item">
              <p className="feelslike__desc">Pressure</p>
              <h2 className="feelslike__text">{weather.main.pressure} hPa</h2>
              <img className="feelslike__img" src={image1} alt="Pressure" />
            </li>
            <li className="feelslike__item">
              <p className="feelslike__desc">Wind speed</p>
              <h2 className="feelslike__text">{weather.wind.speed} m/s</h2>
              <img className="feelslike__img" src={image4} alt="Wind" />
            </li>
            <li className="feelslike__item">
              <p className="feelslike__desc">Visibility</p>
              <h2 className="feelslike__text">
                {weather.visibility / 1000} km
              </h2>
              <img className="feelslike__img" src={image2} alt="Visibility" />
            </li>
          </ul>
        </div>
      </Container>
    </section>
  );
};